export default {
    key: "cp_rsr_api_log",
    id: "api_log_id",
    type: "readonly",
    export: ["excel"],
    excel: {
        //max_row:"50000"
    },
    sort: {
        field: "api_log_id",
        order: "desc"
    },
    sort_fields: [
        "api_log_id",
        "cre_dttm",
        "url",
        "api_log_type"
    ],
    filters:{
        api_log_type:{},
        url:{},
        cre_dttm: {
            type: "daterange"
        }
    },
    action: ["view"],
    view: [
        ["api_log_type"],
        ["url"],
        ["request_data"],
        ["response_data"],

    ],
    fields:[
        { key: "id", field:"api_log_id", width:50},
        { key: "cre_dttm", type: "datetime", width:120},
        { key: "api_log_type", width:150},
        { key: "url", width:300},
        { key: "request_data"},
        { key: "response_data"},
        {key: "action_button", type: "action-btn", width: "45px"},
    ]
}